import { useTranslation } from "react-i18next";
import ClubScopeShell from "@/components/club-scope-shell";
import LimitsForm from "./limits-form";

export default function LimitsPage() {
  const { t } = useTranslation();

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 lg:py-8 max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="font-heading text-xl sm:text-2xl font-bold text-neutral-800 mb-1">
          {t("limits.title")}
        </h1>
        <p className="text-sm text-neutral-500">{t("limits.subtitle")}</p>
      </div>

      <ClubScopeShell>
        {(clubId) => <LimitsForm clubId={clubId} />}
      </ClubScopeShell>
    </div>
  );
}
